import { render, staticRenderFns } from "./EnhancedNotifications.vue?vue&type=template&id=720d83a6&scoped=true"
import script from "./EnhancedNotifications.vue?vue&type=script&lang=js"
export * from "./EnhancedNotifications.vue?vue&type=script&lang=js"
import style0 from "./EnhancedNotifications.vue?vue&type=style&index=0&id=720d83a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720d83a6",
  null
  
)

export default component.exports